<div fxLayout="column" fxLayoutGap="1em">
  <ng-container *ngFor="let item of list">
    <lbl-app-ui-contenuto-chiosco [item]="item" [itemSelected]="itemSelected" [showType]="showType"
      (selectedItem)="selectedItem.emit($event)">
    </lbl-app-ui-contenuto-chiosco>
  </ng-container>
</div>
